
//Popin
document.addEventListener("DOMContentLoaded", (event) => {

    const TopbarPopinOpen = document.getElementsByClassName('__TopbarPopin-open');
  
    Array.prototype.forEach.call(TopbarPopinOpen,
      function(CurrentPopin) {
        let TopbarPopinBtnOpen = CurrentPopin.getAttribute('data-popinid');
        let TopbarPopinContent = document.getElementById(TopbarPopinBtnOpen);
        let TopbarPopinBtnClose = TopbarPopinContent.querySelector('.__TopbarPopin-close');
  
        CurrentPopin.addEventListener('click', () => {
          TopbarPopinContent.classList.add("TopbarPopin--active");
        });
        TopbarPopinBtnClose.addEventListener('click', () => {
          TopbarPopinContent.classList.remove("TopbarPopin--active");
        });
      });
      
      
  });
  
  document.addEventListener('click', function(event) {
    // Sélectionne la classe que tu veux exclure des clics
    const classToExclude = '__TopbarPopin-open';
    const classToExclude2 = 'TopbarPopin--active';
    const classToExclude3 = 'mgmenu';
    const classToExclude4 = 'mgmenu__inner';

    // Vérifie si l'élément cliqué ou l'un de ses parents contient la classe à exclure
    if (event.target.closest(`.${classToExclude}`) || event.target.closest(`.${classToExclude2}`) || event.target.closest(`.${classToExclude3}`) || event.target.closest(`.${classToExclude4}`) ) {
        // Si c'est le cas, ne fais rien et quitte la fonction
        return;
    } else {        
      document.querySelectorAll('.TopbarPopin--active').forEach(function(div) {
        div.classList.remove("TopbarPopin--active");
      });
      document.querySelectorAll('.mgmenu--active').forEach(function(div) {
        div.classList.remove("mgmenu--active");
      });
    }

    // Si le clic n'est pas sur l'élément à exclure ou ses descendants, exécute ton code
    // console.log('Clic détecté en dehors des éléments exclus.');
});


// Sélectionne tous les éléments li ayant la classe 'mgmenu'
const mgmenuItems = document.querySelectorAll('li.mgmenu');

// Ajoute un gestionnaire de clic à chaque élément
mgmenuItems.forEach(item => {
  item.addEventListener('mouseover', function(event) {
    
    // Vérifie si l'élément survolé est un lien direct dans le li.mgmenu et non un lien enfant
    const hoveredLink = event.target.closest('a'); // Vérifie si un lien a été survolé

    if (hoveredLink && item.contains(hoveredLink) && hoveredLink.parentElement === item) {
      // Si le lien est directement dans le li.mgmenu, on bloque l'action par défaut
      event.preventDefault();
    }

    // Supprime la classe 'active' des autres éléments (facultatif)
    mgmenuItems.forEach(el => {
      // Ajouter l'animation directement via JavaScript
      item.querySelector('div').classList.add('mgmenu--fade');
      el.classList.remove('mgmenu--active')
    });

    // Ajoute la classe 'active' à l'élément survolé
    this.classList.add('mgmenu--active');
  });
});

// Ajoute un gestionnaire de survol pour détecter le survol en dehors de .mgmenu
document.addEventListener('mouseover', function(event) {

  const isMgmenu = event.target.closest('li.mgmenu');
  const isSiteHeaderSearch = event.target.closest('.site-header__search') || event.target.closest('.site-header__border');

  if (!isMgmenu && !isSiteHeaderSearch) {
    document.querySelectorAll('li.mgmenu.mgmenu--active').forEach(function(item) {
      item.classList.remove('mgmenu--active');
    });
  }
});

